<template>
  <div class="main_home">
    <div class="main_header">
        <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
            {{ company.name }}
        </h1>
    </div>
    <div class="main_title" style="margin-top:40px;">
        <ul style="overflow:hidden;margin:0;padding:0;">
            <li>
                <el-image fit="cover"  class="main_title_img" :src="require('@/assets/password.png')">
                </el-image>
            </li>
            <li>
                <span>
                    忘记密码
                </span>
            </li>
        </ul>
    </div>
    <div class="main_content" style="margin-top:50px;">
        <ul style="overflow:hidden;">
            <li style="width:100%;height:70px;">
                <a-input v-model="email" type="email" @pressEnter="bind" placeholder="请输入邮箱" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input>
            </li>
            <li style="width:100%;height:70px;margin-top:50px;">
                <a-button :loading="commit_loading" @click="send" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                    发送修改密码地址到邮箱
                </a-button>
            </li>
        </ul>
    </div>
    <div class="register_footer">
        <ul style="width:100%;height:100%;">
            <li style="float:left;height:100%;width:40%;margin-left:10%;">
                <router-link to="/home" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/account_login.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                会员中心
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
            <li style="float:right;height:100%;width:40%;margin-right:10%;">
                <router-link to="/" class="member_home_a">
                    <ul style="text-align:center;">
                        <li>
                            <el-image fit="cover"  class="member_quit_img" :src="require('@/assets/quit.png')">
                                
                            </el-image>
                        </li>
                        <li>
                            <a class="member_quit_a">
                                安全退出
                            </a>
                        </li>
                    </ul>
                </router-link>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>

import request from "../../api/request"
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'ForgetPassword',
    head: {
        title: "忘记密码",
        meta:[
            { name: 'description', content: '忘记密码'}
        ]
    },
    data() {
        return {
            email: undefined,
            commit_loading: false,
            company: company_model,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        send() {
            if (!this.email) {
                this.$message.error("请输入邮箱地址")
                return
            }
            this.commit_loading = true
            let resp = request.site_user.forget_password(this.email)
            resp.then((response) => {
                this.commit_loading = false
                if (response.status == 200 && response.data.code == 0) {
                    var success_message = response.data.message
                    if (!success_message) {
                        success_message = "发送成功"
                    }
                    this.$message.success(success_message)
                }
                else {
                    var failed_message = response.data.message
                    if (!failed_message) {
                        failed_message = "发送失败"
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.commit_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
        }
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

</style>
